/*
 * Copyright (c)  2018 by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 * author : nk
 * date : 26/10/18 10:31
 */

import { inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { InitService } from '../service/init.service';
import { AuthorizationService } from './authorization.service';
import { WebsocketService } from '../service/websocket.service';

/**
 * Gestion des guards : laisse passer ou non vers la page/contenu demande
 * @deprecated: use `authorizationGuardFn` instead
 *
 */
@Injectable({
  providedIn: 'root',
})
export class AuthorizationGuard {
  public readonly initService = inject(InitService);
  private readonly authorizationService = inject(AuthorizationService);
  private readonly websocketService = inject(WebsocketService);

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.initService.isLoaded) {
      this.websocketService.connect(this.authorizationService.token);
      return true;
    } else {
      const obs = new Subject<boolean>();
      this.initService.isConfigLoaded.subscribe((result) => {
        if (result) {
          this.initService.isLoaded$.subscribe((res) => {
            if (res) {
              this.websocketService.connect(this.authorizationService.token);
              obs.next(true);
            }
          });
          this.authorizationService.init();
        }
      });
      return obs;
    }
  }
}
